import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../core/data/routes';
import { ZeroState, FadeInAnimation } from '../../../core/components/ui';

interface Assessment {
  id: string;
  title: string;
  description: string;
  questions: number;
  duration: string;
  category: string;
}

const ASSESSMENTS: Assessment[] = [
  {
    id: 'phq9',
    title: 'PHQ-9 Depression Scale',
    description: 'Patient Health Questionnaire for measuring depression severity.',
    questions: 9,
    duration: '5 min',
    category: 'Depression',
  },
  {
    id: 'gad7',
    title: 'GAD-7 Anxiety Scale',
    description: 'Generalized Anxiety Disorder assessment tool.',
    questions: 7,
    duration: '4 min',
    category: 'Anxiety',
  },
  {
    id: 'pcl5',
    title: 'PCL-5 PTSD Checklist',
    description: 'DSM-5 based self-report measure for PTSD symptoms.',
    questions: 20,
    duration: '10 min',
    category: 'Trauma',
  },
  {
    id: 'audit',
    title: 'AUDIT Alcohol Use',
    description: 'Alcohol Use Disorders Identification Test.',
    questions: 10,
    duration: '6 min',
    category: 'Substance Use',
  },
];

const AssessmentsTab: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '16px 16px 0' }}>
      <p style={{ fontSize: 13, color: 'var(--color-on-surface-variant)', marginBottom: 16, lineHeight: 1.5 }}>
        Complete these assessments to help your therapist better understand your needs.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {ASSESSMENTS.map((a, i) => (
          <FadeInAnimation key={a.id} delay={i * 0.08}>
            <div
              className="card"
              onClick={() => navigate(ROUTES.ASSESSMENT_DETAILS, { state: { assessment: a } })}
              role="button"
              tabIndex={0}
              onKeyDown={e => e.key === 'Enter' && navigate(ROUTES.ASSESSMENT_DETAILS, { state: { assessment: a } })}
              style={{ cursor: 'pointer' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{a.title}</div>
                  <p style={{ fontSize: 12, color: 'var(--color-on-surface-variant)', lineHeight: 1.5 }}>{a.description}</p>
                </div>
                <span style={{
                  marginLeft: 10, padding: '4px 10px', borderRadius: 99, flexShrink: 0,
                  background: 'var(--color-primary-container)',
                  color: 'var(--color-on-primary-container)',
                  fontSize: 11, fontWeight: 600,
                }}>
                  {a.category}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--color-on-surface-variant)" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                  </svg>
                  <span style={{ fontSize: 12, color: 'var(--color-on-surface-variant)' }}>{a.questions} questions</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--color-on-surface-variant)" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                  </svg>
                  <span style={{ fontSize: 12, color: 'var(--color-on-surface-variant)' }}>{a.duration}</span>
                </div>
              </div>
            </div>
          </FadeInAnimation>
        ))}
      </div>
      <div style={{ height: 16 }} />
    </div>
  );
};

export default AssessmentsTab;
